/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_PositionInputs */

const en_entity_position = /** @type {(inputs: Entity_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const de_entity_position = /** @type {(inputs: Entity_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Entity_PositionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_position = /** @type {((inputs?: Entity_PositionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_PositionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_position(inputs)
	return de_entity_position(inputs)
});